const migrations = {
  0: (state: any) => {
    return state;
  },
};

export default migrations;
